import { textColor as textColor_1 } from './textColor.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { RibbonButton, RibbonDropDownProps } from './RibbonButton';

import { ColorPicker, textColors } from 'owa-color-picker';
import { setTextColor } from 'roosterjs-editor-api';

const textColor: RibbonButton = {
    key: 'textColor',
    title: () => loc(textColor_1),
    imageSrc: require('../svg/textcolor.svg'),
    createDropDownCallback: React.memo(
        ({ target, plugin, dismiss, logUsage }: RibbonDropDownProps) => {
            const onSelectColor = React.useCallback(
                color => {
                    const editor = plugin.getEditor();
                    setTextColor(editor, color.colorCode);
                    logUsage('setTextColor', [color.colorCode.lightModeColor, editor.isDarkMode()]);
                },
                [plugin]
            );
            return (
                <ColorPicker
                    menuTargetElement={target}
                    onDismissMenu={dismiss}
                    colors={textColors.get()}
                    onSelectColor={onSelectColor}
                    shouldFocusOnMount={true}
                    selectedColor={plugin.getFormatState().textColor}
                />
            );
        }
    ),
};

export default textColor;
